"use client";

const Error = () => null;

export default Error;
